import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-navigation-bar-desktop',
  templateUrl: './navigation-bar-desktop.component.html',
  styleUrls: ['./navigation-bar-desktop.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationBarDesktopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/navigation-bar-desktop/navigation-bar-desktop.component.ts